export default __webpack_public_path__ + "static/media/stop.68fe879c.svg";